import {Box, FormControl, Grid, InputLabel, Select} from "@mui/material"
import MenuItem from '@mui/material/MenuItem'
import React, { useState } from "react"
import LayoutPage from "src/components/page-layout/layout-page"
import { parameterCalcTableList } from "./parameter-calc-data"
import AlertMessage from "../../../components/alert-message"


const ParameterCalcPage = () => {

    const [tableSelected, setTableSelected] = useState("")
    const [loading, setLoading] = useState(false)
    const [endpointSelected, setEndpointSelected] = useState("")
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: "info"
    })

    const setTable = (event) => {
        const table = event.target.value
        setTableSelected(table)

        if (!table) return
        const { endpoint, component, app, model } = parameterCalcTableList.find(item => item.key === table)       
        const Comp = component      
        const SelectedComponent = (
            <Comp
                endpoint={`${endpoint}?app=${app}&model=${model}`}
                loading={setLoading}
                callbackError={openAlertError}
            />
        )

        setEndpointSelected(SelectedComponent)
    }

    const openAlertError = (error) => {
        console.log(error)
        openAlert("Não foi possível carregar os dados.", "error")
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    return (
        <LayoutPage title="Parâmetros" loading={loading}>
            <AlertMessage open={alertMessageState.open} message={alertMessageState.message} type={alertMessageState.type} close={() => setAlertMessageState({ ...alertMessageState, open: false })} />
            <Box sx={{mx: 2, width: 'auto'}}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4} xl={4}>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="select-tabela">Tabela</InputLabel>
                            <Select
                                fullWidth
                                labelId="select-tabela"
                                id="select-tabela-id"
                                value={tableSelected}
                                label="Tabela"
                                onChange={setTable}
                            >
                                {
                                    parameterCalcTableList
                                        .sort((a, b) => a.label.localeCompare(b.label))
                                        .map((item) => {
                                            return (
                                                <MenuItem key={item.key} value={item.key}
                                                          disabled={item.disable || false}>
                                                    {item.label}
                                                </MenuItem>
                                            )
                                        })
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        {endpointSelected}
                    </Grid>
                </Grid>
            </Box>
        </LayoutPage>
    )
}

export default ParameterCalcPage